<script lang="ts">
import {
  defineComponent,
  useSlots,
  onMounted,
} from 'vue'
import HeaderSignUp from '@/components/_core/HeaderSignUp.vue'
import MediaQueryObserver from '@/components/_core/MediaQueryObserver.vue'
import LoadingScreen from '@/components/loading/LoadingScreen.vue'
import ToastMessage from '@/components/toast/ToastMessage.vue'
import { useScreenLockStore } from '@/stores/screenLock'
import { useClientStore } from '@/stores/client'

export default defineComponent({
  name: 'TemplateDefault',

  components: {
    HeaderSignUp,
    MediaQueryObserver,
    LoadingScreen,
    ToastMessage,
  },

  props: {
    hasLogoLink: {
      type: Boolean,
      default: true,
    },

    hasSignInLink: {
      type: Boolean,
      default: true,
    },
  },

  setup() {
    // store
    const screenLockStore = useScreenLockStore()
    const clientStore = useClientStore()

    const slots = useSlots()

    onMounted(() => {
      if (!slots.main) {
        console.error('This page doesn\'t have main contents. Please inject a main slot into App.')
      }

      clientStore.setIsTouchDevice()
    })

    return {
      // store
      screenLockStore,
      clientStore,
    }
  },
})
</script>

<template>
  <div
    ref="root"
    class="f-container"
    :data-app="clientStore.context.isApp"
    :data-screenlock="screenLockStore.isLock ? 'true' : 'false'"
    :data-backdrop-darken="screenLockStore.isBlackOut"
    :data-backdrop-blur="screenLockStore.isBlur">
    <div
      id="global-container"
      class="f-container--body">
      <HeaderSignUp
        v-if="!clientStore.context.isApp"
        :has-logo-link="hasLogoLink"
        :has-sign-in-link="hasSignInLink" />

      <div
        class="l-cols__mainGrid"
        :data-app="clientStore.context.isApp">
        <div class="l-cols__mainGrid--col is-primary">
          <section
            class="f-section__contents"
            :data-app="clientStore.context.isApp">
            <div class="f-section__contents--body is-primary">
              <main class="main">
                <slot name="main" />
              </main>
            <!-- /.f-section__contents body --></div>
          <!-- /.f-section__contents --></section>
        <!-- /.l-cols__mainGrid col --></div>
      <!-- /.l-cols__mainGrid --></div>

      <!-- overlay contents -->
      <LoadingScreen :is-show="screenLockStore.showWaitAnimation" />
      <ToastMessage />
      <MediaQueryObserver />
    <!-- /.f-container body --></div>
  <!-- /.f-container --></div>
</template>

<style lang="sass" scoped>
$global-top-gutter-px: 20
.f-container
  $root: &
  width: 100%
  height: 100%
  min-height: 100%

  &::before
    content: ''
    +transition

  &[data-screenlock="true"]
    &::before
      width: 100%
      height: 100%
      display: block
      position: fixed
      top: 0
      left: 0
      z-index: 20

    &[data-backdrop-darken="true"]::before
      background-color: rgba($bg-black, 0.56)

    // スクリーンロック時に「ぼかし」を入れる場合
    &[data-backdrop-blur="true"]::before
      -webkit-backdrop-filter: blur(6px)
      backdrop-filter: blur(6px)

    &:not([data-backdrop-darken="true"])[data-backdrop-blur="true"]::before
      background-color: rgba($bg-white, 0.3)

  & &--body
    min-height: 100%
    display: flex
    flex-direction: column
    background-color: rgba($bg-x-light-gray, 1)

.f-section__contents
  $root: &
  $margin-size: $global-contents-width-pc - ($primary-col-width + $secondary-col-width)
  width: 100%
  max-width: #{$global-width-pc}px
  flex-grow: 1
  margin: 0 auto
  padding:
    bottom: 1em
    left: #{$global-prop-pc}px
    right: #{$global-prop-pc}px

  +breakpoint
    width: 100%
    display: block
    padding:
      left: 0
      right: 0

    #{$root}--body
      &.is-primary
        padding: 0 #{$global-prop-sp}px
</style>
